
export function rgbToHex(r, g, b) {
  function _componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  return "#" + _componentToHex(r) + _componentToHex(g) + _componentToHex(b);
}

export function hexToRgb(hex, alpha = 1) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  return [r, g, b, Math.round(alpha * 255)]
}

export function importAllImages(r) {
  let images = {};
  r.keys().map(item => { images[item.replace('./', '')] = r(item); });
  return images;
}

export function mapToArray(map) {
  if (!map) return []
  return Object.keys(map).map(key => map[key])
}

export function sortAsc(arr) {
  return arr.slice().sort((a, b) => a.createdAt > b.createdAt ? 1 : -1)
}

export function sortDesc(arr) {
  return arr.slice().sort((a, b) => a.createdAt > b.createdAt ? -1 : 1)
}

export function userPicUploadUrl(userId) {
  return 'user-pic-' + userId
}

export function promisedUrlToImgDataUrl(url) {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(res => res.blob())
      .then(blob => {

        const reader = new FileReader();

        reader.onload = function () {
          resolve(this.result)
        }

        reader.readAsDataURL(blob);
      })
      .catch(reject)
  })
}

export function isMobileOrTablet() {
  return window.matchMedia("(any-pointer:coarse)").matches || "ontouchstart" in document.documentElement
}
